export default "__VITE_ASSET__D3s8vRzr__"